const LS_SELECTED_DEBRIEF_KEY = 'selectedDebrief';

export { LS_SELECTED_DEBRIEF_KEY }


// WEBPACK FOOTER //
// ./src/pages/SummaryReport/components/Debriefs/util.js